
import { useractivationService } from "../../../../admin/services/useractivation.service";

import { UntypedFormControl } from '@angular/forms';
import { timer } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

import { JwtHelperService } from '@auth0/angular-jwt';

export const OldPwdAsyncValidator = (useractivationService: useractivationService, time: number = 500) => {

  let decodeHelper = new JwtHelperService();
  let decodedTkn = decodeHelper.decodeToken(localStorage.getItem('access_token'));

  return (input: UntypedFormControl) => {
    return timer(time).pipe(
      switchMap(() => useractivationService.checkPwd({
        password: input.value,
        username: decodedTkn.UserId
      })),
      map(res => {
        //return false ? null : { loginExist: true };
        return res.success ? null : { loginExist: true };
      })
    );
  };
};
